import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { toast4hp3bb4ymp24 as toast } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { EmployerDetailPage15t2ca6578ek0 as EmployerDetailPage } from './EmployerDetailPage.mjs';
import { IDqqik72jjbpsn as ID } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { nowLocal2mdv5rmil2cf2 as nowLocal } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { LocalDateRangefowoyqa24icz as LocalDateRange } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import { _ExcelLikeFormula___init__impl__5newgny7l2ajw10exm as _ExcelLikeFormula___init__impl__5newgn } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/excel.mjs';
import { EmployerRate2h2cumt5qtpn7 as EmployerRate } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/subsidyRates.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { maxWidth22r11xnm7d4h4 as maxWidth } from '../components/view-utilities.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  LabeledView$_get_content_$ref_5yojet1mvh3jfqyuzca as LabeledView$_get_content_$ref_5yojet,
  LabeledView$_set_content_$ref_ys1c8fi8j7ehqqddvg as LabeledView$_set_content_$ref_ys1c8f,
} from '../LoginScreen.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_careProvider2yy6e55u6ryn2 as get_careProvider,
  get_administration1i905jzi65gk6 as get_administration,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { lensPath21i5dxhjzuxep as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import {
  CareDayInfoge91quhezyzw as CareDayInfo,
  CareDayInfoWithEmployerSubsidybae42h7dxu4n as CareDayInfoWithEmployerSubsidy,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/excelInputs.mjs';
import { serializer1hwzc6m64v1op as serializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { default1jaun537xukbl as default_0 } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Defaults.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { formulaBuilderqnttj5yf43zm as formulaBuilder } from '../components/formulaTester.mjs';
import { h2ld0l0a2c9zpb as h2 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { CanBlockBacknswc7za76703 as CanBlockBack } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/CanBlockBack.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function actionBar($this, $receiver) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($receiver.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $receiver.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed(element, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, NewEmployerRatePage$actionBar$lambda);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  onClick(element_0, VOID, VOID, VOID, NewEmployerRatePage$actionBar$slambda(element_0));
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Space())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_2 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_3 = themed(this_2, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Button())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element_3.willAddChild_hz2iwc_k$(element_4);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_4, NewEmployerRatePage$actionBar$lambda_0);
  element_4.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_4);
  element_3.set_action_2ds022_k$(Action('Add rate', VOID, VOID, VOID, VOID, VOID, NewEmployerRatePage$actionBar$slambda_0($this, element_3)));
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  $receiver.addChild_2qpft2_k$(element);
}
function NewEmployerRatePage$_get_title_$lambda_501fe4($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerNewRatePageTitle_lgm6tv_k$();
}
function NewEmployerRatePage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateInForceFromLabel_hamky5_k$();
}
function NewEmployerRatePage$render$lambda_0(it) {
  return it.activeRange_1.start_1;
}
function NewEmployerRatePage$render$lambda_1(old, new_0) {
  return old.copy$default_5hu96p_k$(VOID, VOID, old.activeRange_1.copy$default_iikz6e_k$(new_0 == null ? old.activeRange_1.start_1 : new_0));
}
function NewEmployerRatePage$render$lambda_2($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerShareOfDayLabel_l9g9iu_k$();
}
function NewEmployerRatePage$render$lambda_3($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
function NewEmployerRatePage$actionBar$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function NewEmployerRatePage$actionBar$slambda($$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    get_pageNavigator($$this$button.get_context_h02k06_k$()).goBack_kj7lzl_k$();
    return Unit_instance;
  }), 0);
}
function NewEmployerRatePage$actionBar$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_employerAddRateButton_bne9o1_k$();
}
function NewEmployerRatePage$actionBar$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues(this$0.rate_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      return Unit_instance;
    }
    var saved = yield* this$0.rate_1.publish_xq9q2e_k$($completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_currentSessionNotNull();
    yield* (yield* await_0(this_1, $completion)).get_employerRates_stalch_k$().add_co22jy_k$(saved, $completion);
    var tmp_0 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_strings(AppState_getInstance());
    var tmp$ret$3 = yield* await_1(this_2, $completion);
    toast(tmp_0, tmp$ret$3.get_employerRateAddedToast_vme6ol_k$());
    get_pageNavigator($$this$button.get_context_h02k06_k$()).replace_7qh33u_k$(new (EmployerDetailPage())(this$0.employerId_1));
    return Unit_instance;
  }), 1);
}
var NewEmployerRatePageClass;
function NewEmployerRatePage() {
  if (NewEmployerRatePageClass === VOID) {
    class $ {
      constructor(employerId) {
        this.employerId_1 = employerId;
        var tmp = this;
        tmp.employer_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.awaitNotNull_2lqt5h_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$().get_6ueaa7_k$(new (ID())(this.employerId_1))));
        var tmp_0 = this;
        tmp_0.rate_1 = validated(Draft(($this$Draft) => {
          var tmp0_employer = this.employerId_1;
          var tmp1_activeRange = new (LocalDateRange())(nowLocal().get_date_wokkxj_k$());
          var tmp2_careProvider = _ExcelLikeFormula___init__impl__5newgn('OWED * 0.6');
          var tmp3_administration = _ExcelLikeFormula___init__impl__5newgn('PAIDBYEMPLOYER * 0.15');
          return new (EmployerRate())(VOID, tmp0_employer, tmp1_activeRange, tmp3_administration, tmp2_careProvider);
        }));
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, NewEmployerRatePage$_get_title_$lambda_501fe4);
      }
      onNavigateAwayAttempt_vrrtsh_k$() {
        return !(ReactiveState__getOrNull_impl_1asnfp(this.rate_1.get_changesMade_d6j01d_k$().get_state_wc71uu_k$()) === true);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (TextView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
        element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).employerAddRateHeading_yj9ltq_k$($this$invoke.invoke_r7m7el_k$(this.employer_1).name_1));
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (Separator())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        element.willAddChild_hz2iwc_k$(element_1);
        element_1.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_1);
        actionBar(this, element);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_2 = themed(element, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_2.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        element_2.willAddChild_hz2iwc_k$(element_3);
        var tmp_2 = KMutableProperty0();
        var tmp_3 = LabeledView$_get_content_$ref_5yojet(element_3);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, LabeledView$_set_content_$ref_ys1c8f(element_3));
        element_3.invoke_bnq13k_k$(tmp_4, NewEmployerRatePage$render$lambda);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
        var this_3 = themed(element_3, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (LocalDateField())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_3.willAddChild_hz2iwc_k$(element_4);
        var tmp_5 = NewEmployerRatePage$render$lambda_0;
        element_4.bind_gesskf_k$(element_4.content_1, this.rate_1.lens_u4wb4z_k$(tmp_5, NewEmployerRatePage$render$lambda_1));
        element_4.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_4);
        errorText(element_3);
        element_3.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_3);
        element_2.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_4 = themed(element, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (RowOrCol())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_4.willAddChild_hz2iwc_k$(element_5);
        element_5.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (TextView())(element_5.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        element_5.willAddChild_hz2iwc_k$(element_6);
        element_6.set_themeChoice_py59um_k$(element_6.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
        var tmp_6 = KMutableProperty0();
        var tmp_7 = TextView$_get_content_$ref_4pzcwl(element_6);
        var tmp_8 = getPropertyCallableRef('content', 0, tmp_6, tmp_7, TextView$_set_content_$ref_pketfb(element_6));
        element_6.invoke_bnq13k_k$(tmp_8, NewEmployerRatePage$render$lambda_2);
        element_6.onStartup_vrxh3i_k$();
        element_5.addChild_2qpft2_k$(element_6);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_5 = this.rate_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_9 = serializerOrContextual(createKType(getKClass(EmployerRate()), arrayOf([]), false));
        var tmp$ret$38 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$38);
        var tmp$ret$39 = get_careProvider(it);
        // Inline function 'org.thecommunitygroupinc.cares.views.components.formulaBuilder' call
        var formula = lensPath(this_5, tmp$ret$39);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_6 = serializer(createKType(getKClass(CareDayInfo()), arrayOf([]), false));
        var tmp$ret$41 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
        var testValues = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(default_0(tmp$ret$41));
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_7 = serializer(createKType(getKClass(CareDayInfo()), arrayOf([]), false));
        var tmp_10 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_8 = serializer(createKType(PrimitiveClasses_getInstance().get_doubleClass_dahzcy_k$(), arrayOf([]), false));
        var tmp$ret$45 = isInterface(this_8, KSerializer()) ? this_8 : THROW_CCE();
        formulaBuilder(element_5, tmp_10, tmp$ret$45, formula, testValues);
        element_5.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_5);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_9 = themed(element, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (RowOrCol())(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        this_9.willAddChild_hz2iwc_k$(element_7);
        element_7.set_vertical_nuap32_k$(true);
        h2(element_7, 'Administration fee');
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_10 = this.rate_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_11 = serializerOrContextual(createKType(getKClass(EmployerRate()), arrayOf([]), false));
        var tmp$ret$54 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
        var it_0 = new (DataClassPathSelf())(tmp$ret$54);
        var tmp$ret$55 = get_administration(it_0);
        // Inline function 'org.thecommunitygroupinc.cares.views.components.formulaBuilder' call
        var formula_0 = lensPath(this_10, tmp$ret$55);
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_11 = serializer(createKType(getKClass(CareDayInfoWithEmployerSubsidy()), arrayOf([]), false));
        var tmp$ret$57 = isInterface(this_11, KSerializer()) ? this_11 : THROW_CCE();
        var testValues_0 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(default_0(tmp$ret$57));
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_12 = serializer(createKType(getKClass(CareDayInfoWithEmployerSubsidy()), arrayOf([]), false));
        var tmp_12 = isInterface(this_12, KSerializer()) ? this_12 : THROW_CCE();
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_13 = serializer(createKType(PrimitiveClasses_getInstance().get_doubleClass_dahzcy_k$(), arrayOf([]), false));
        var tmp$ret$61 = isInterface(this_13, KSerializer()) ? this_13 : THROW_CCE();
        formulaBuilder(element_7, tmp_12, tmp$ret$61, formula_0, testValues_0);
        element_7.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_7);
        actionBar(this, element);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (Separator())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        element.willAddChild_hz2iwc_k$(element_8);
        element_8.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_14 = shownWhen(element, VOID, VOID, NewEmployerRatePage$render$lambda_3);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (Space())(this_14.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_9);
        this_14.willAddChild_hz2iwc_k$(element_9);
        element_9.onStartup_vrxh3i_k$();
        this_14.addChild_2qpft2_k$(element_9);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'NewEmployerRatePage', VOID, VOID, [Page(), CanBlockBack()]);
    NewEmployerRatePageClass = $;
  }
  return NewEmployerRatePageClass;
}
//region block: exports
export {
  NewEmployerRatePage as NewEmployerRatePagegotlrdlenb2b,
};
//endregion

//# sourceMappingURL=NewEmployerRatePage.mjs.map
